import { render, staticRenderFns } from "./NoDatabases.vue?vue&type=template&id=3262fa38&scoped=true"
import script from "./NoDatabases.vue?vue&type=script&lang=js"
export * from "./NoDatabases.vue?vue&type=script&lang=js"
import style0 from "./NoDatabases.vue?vue&type=style&index=0&id=3262fa38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3262fa38",
  null
  
)

export default component.exports